import React from 'react';
import { ActionIcon, Paper, Stack, Text, Tooltip } from '@mantine/core';
import { BUILD_DATUM, BUILD_TIJD } from '../buildinfo';

// Verticale kaart-toolbar links: menu-toggle + stationsacties (op buurtniveau).
function MapToolbar({
  setSidebarOpen,
  level,
  addStationMode,
  setAddStationMode,
  deleteStationMode,
  setDeleteStationMode,
  moveStationMode,
  setMoveStationMode,
  koppelMode,
  setKoppelMode,
  percelenOverlay,
  setPercelenOverlay,
}) {
  const modusKnop = (actief, setActief, kleur, titel, pad) => (
    <Tooltip label={titel} position="right" withArrow>
      <ActionIcon
        onClick={() => setActief(v => !v)}
        variant={actief ? 'filled' : 'default'}
        color={kleur}
        size={48}
        radius="md"
        aria-label={titel}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d={pad} />
        </svg>
      </ActionIcon>
    </Tooltip>
  );

  return (
    <Paper
      shadow="md"
      radius={0}
      style={{
        position: 'absolute', top: 0, left: 0, width: 64, height: '100vh',
        zIndex: 20, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'space-between',
      }}
    >
      <Stack align="center" gap="sm" pt="md">
        <ActionIcon
          onClick={() => setSidebarOpen(v => !v)}
          variant="subtle" color="gray" size="lg" aria-label="Menu"
        >
          <svg width="28" height="28" viewBox="0 0 32 32">
            <rect y="7" width="32" height="4" rx="2" fill="currentColor" />
            <rect y="14" width="32" height="4" rx="2" fill="currentColor" />
            <rect y="21" width="32" height="4" rx="2" fill="currentColor" />
          </svg>
        </ActionIcon>

        {level === 'buurt' && (
          <>
            {modusKnop(addStationMode, setAddStationMode, 'green', 'Station toevoegen',
              'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z')}
            {modusKnop(deleteStationMode, setDeleteStationMode, 'red', 'Station verwijderen',
              'M19 13H5v-2h14v2z')}
            {modusKnop(moveStationMode, setMoveStationMode, 'orange', 'Station verplaatsen',
              'M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z')}
            {/* Schakelicoon: koppelt het vervangende station aan het station dat het vervangt */}
            {modusKnop(koppelMode, setKoppelMode, 'blue', 'Te vervangen station koppelen',
              'M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z')}
          </>
        )}
      </Stack>

      {/* Onderin: optionele kaartoverlays (projectniveau) + app-versie */}
      <Stack align="center" gap="xs" pb={6}>
        {level === 'project' && modusKnop(
          percelenOverlay, setPercelenOverlay, 'grape', 'Percelen met recht (MOOR)',
          'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z',
        )}
        <Text
          component="div" ff="monospace" size="10px" c="dimmed" ta="center"
          title="App-versie (buildtijd)"
          style={{ lineHeight: 1.15 }}
        >
          {BUILD_DATUM}<br />{BUILD_TIJD}
        </Text>
      </Stack>
    </Paper>
  );
}

export default MapToolbar;
